module.exports = __webpack_public_path__ + "static/media/Cuadricula_2.79222563.svg";